// extracted by mini-css-extract-plugin
export default {"remainingTime":"JJ6Wg","time":"i9B8l"};